import { RootState } from '../../../config';
import {
  OutputDamageData,
  FleetRentalData,
  FleetReceiptData,
} from '../../../../@types';

export const selectClaims = (state: RootState): OutputDamageData[] | null =>
  state.userData.claims.entities;

export const selectDisplayClaims = (
  state: RootState
): OutputDamageData[] | null => state.userData.claims.display;

export const selectTotalClaims = (state: RootState): number | null =>
  state.userData?.claims?.totalDamages;

export const selectSelectedClaim = (
  state: RootState
): OutputDamageData | null => state.userData.claims.selected;

export const selectAssignableClaimTrips = (
  state: RootState
): FleetRentalData[] | null => state.userData.claims.assignableClaimTrips;

export const selectClaimUserReceipts = (
  state: RootState
): FleetReceiptData[] | null => state.userData.claims.claimUserReceipts;

export const selectClaimUserReceiptsLoading = (state: RootState): boolean =>
  state.userData.claims.claimUserReceiptsLoading;

export const selectIsClaimUpdating = (state: RootState): boolean =>
  state.userData.claims.isUpdating;

export const selectIsLocadingCarClaims = (state: RootState): boolean =>
  state.userData.claims.isLoadingCarClaim;

export const selectTotalDamages = (state: RootState): number =>
  state.userData.claims.totalDamages;

export const selectClaimsLoading = (state: RootState): boolean =>
  state.userData.claims.loading;

export const selectIsInitialClaimsLoad = (state: RootState): boolean =>
  state.userData.claims.loading && !state.userData.claims.entities?.length;
